import { FC } from 'react';

// Utils
import { classNames } from '@sportal365/smp-widget-utils';

interface Props {
  name: string;
  value: string;
  isLastRow: boolean;
}

const StatisticRow: FC<Props> = ({ name, value, isLastRow }) => {
  return (
    <div
      className={classNames({
        'stats-row min-h-[90px] bg-statsContainerBackgroundColor box-border rounded-4 flex flex-col justify-between py-2 px-4 sm:p-4': true,
        'sm:w-auto w-[calc(100vw-32px)]': isLastRow,
      })}
    >
      <span className='stats-row-label text-4 text-playerSecondaryTextColor capitalize'>{name}</span>
      <p className='stats-row-value text-7 font-bold text-hiContrast mt-1 mb-0 mx-0 sm:mt-2 sm:mb-0 sm:mx-0'>{value}</p>
    </div>
  );
};

export default StatisticRow;
